module.exports = __webpack_public_path__ + "img/trophy-icon.7d8e7d15.svg";